import { withInstall } from "@/shared/lib/utils"
import Button from "./src/ui/button.vue"

export const CButton = withInstall(Button)
export default CButton


export * from "./src/model"
